import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { cambiarPassword, cerrarSesion, guardarSesion, leerSesion, mensajeDeError } from '../api';
import { useTema } from '../tema';
import BotonTema from '../componentes/BotonTema';

const MINIMO = 8;

/**
 * Cambiar la contraseña temporal. Es lo único que se puede hacer hasta cambiarla.
 *
 * No es un trámite de cortesía: esa clave llegó escrita en un correo, en texto plano, y por ahí
 * pasa mucha gente. Mientras siga puesta, el backend no entrega ni un trámite —así que un
 * correo que alguien más lea no se convierte en una fuga—. Al guardar la nueva, todas las
 * sesiones abiertas con la vieja se caen en el acto.
 */
export default function CambiarPassword() {
  const navegar = useNavigate();
  const { tema, alternar } = useTema();
  const sesion = leerSesion();

  const [nueva, setNueva] = useState('');
  const [repetida, setRepetida] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  const enviar = async (evento) => {
    evento.preventDefault();
    setError('');
    if (nueva.length < MINIMO) {
      setError(`La contraseña debe tener al menos ${MINIMO} caracteres.`);
      return;
    }
    if (nueva !== repetida) {
      setError('Las dos contraseñas no coinciden.');
      return;
    }
    setGuardando(true);
    try {
      const { data } = await cambiarPassword(nueva);
      // El backend devuelve un token nuevo: el anterior deja de valer al cambiar la clave, así
      // que hay que quedarse con este o la siguiente pantalla se cae con un 401.
      guardarSesion(data);
      navegar('/', { replace: true });
    } catch (err) {
      setError(mensajeDeError(err, 'No se pudo cambiar la contraseña.'));
    } finally {
      setGuardando(false);
    }
  };

  const salir = () => {
    cerrarSesion();
    navegar('/ingresar', { replace: true });
  };

  return (
    <div className="login-page">
      <div style={{ position: 'fixed', top: 16, right: 16 }}>
        <BotonTema tema={tema} alternar={alternar} />
      </div>

      <div className="login-card">
        <div className="login-logo">
          <img
            src="/LOGO-WF-long-color.png"
            alt="WF Aduanas y Logística"
            style={{ width: 220, maxWidth: '100%', height: 'auto' }}
          />
        </div>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--titulo)', marginBottom: 6 }}>
          Elija su contraseña
        </div>
        <div style={{ fontSize: 13, color: 'var(--gris-texto)', marginBottom: 18, lineHeight: 1.5 }}>
          {sesion?.nombre ? `${sesion.nombre}, entró ` : 'Entró '}
          con una contraseña temporal que le llegó por correo. Elija una suya para continuar.
        </div>

        <form onSubmit={enviar}>
          <div className="form-group">
            <label className="form-label required" htmlFor="nueva">Contraseña nueva</label>
            <input
              id="nueva" className="form-control" type="password" autoComplete="new-password"
              value={nueva} onChange={(e) => setNueva(e.target.value)}
              placeholder={`Al menos ${MINIMO} caracteres`} required autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label required" htmlFor="repetida">Repítala</label>
            <input
              id="repetida" className="form-control" type="password" autoComplete="new-password"
              value={repetida} onChange={(e) => setRepetida(e.target.value)}
              placeholder="La misma de arriba" required
            />
          </div>

          {error && <div className="alert alert-error" style={{ marginBottom: 14 }}>{error}</div>}

          <button className="btn btn-primary" type="submit" disabled={guardando} style={{ width: '100%' }}>
            {guardando ? 'Guardando…' : 'Guardar y continuar'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <button type="button" className="btn-enlace" onClick={salir}>Salir</button>
        </div>
      </div>
    </div>
  );
}
